angular.module('picmonicng').factory('Notes', [
  '$resource',
  function ($resource) {
    return $resource('/api/v2/notes');
  },
]);
